import React from 'react';
import { NumberToMonth } from '../../constants/Constants';

export default function DateDisplay(props) {
  const day = props.date.getDate();
  const month = NumberToMonth(props.date.getMonth());
  const year = props.date.getFullYear();

  return (
    <span>
      {day} {month} {year}
    </span>
  );
}
